import * as commonScripts from '../common'
const cmpOfficeContact = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
  }
}
export default cmpOfficeContact
